import React from 'react';

import Typography from '@material-ui/core/Typography';

import { WidgetWrapper } from '../../WidgetWrapper';

export const MACAddresses = ({ networkMac }) => {
	return (
		<WidgetWrapper title='MAC Address' displaySave={false}>
			<Typography>station</Typography>
			<Typography variant='h4'>
				{networkMac.station ? networkMac.station.toUpperCase() : 'N/A'}
			</Typography>
			<Typography>ap</Typography>
			<Typography variant='h4'>
				{networkMac.ap ? networkMac.ap.toUpperCase() : 'N/A'}
			</Typography>
			<Typography>bluetooth</Typography>
			<Typography variant='h4'>
				{networkMac.bluetooth ? networkMac.bluetooth.toUpperCase() : 'N/A'}
			</Typography>
		</WidgetWrapper>
	);
};
